<template>
    <app-modal unique="view-hospital" title="View Hospital Details">

        <form @submit.prevent="confirmUpdateHospital">
            <div class="form-group form-row mb-1" :class="{'has-error': hospitalErrors.code}">
                <label for="hospital-code" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Hospital Code:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <input type="text" id="hospital-code" class="form-control form-control-xs"
                           placeholder="No Hospital Code Yet"
                           :readonly="!editable"
                           v-model="hospital.code"
                    >
                    <span class="help-block" v-if="!!hospitalErrors.code">
                      <small><strong>{{ hospitalErrors.code }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': hospitalErrors.name}">
                <label for="hospital-name" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Hospital Name:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <input type="text" id="hospital-name" class="form-control form-control-xs"
                           placeholder="No Hospital Name Yet"
                           :readonly="!editable"
                           v-model="hospital.name"
                    >
                    <span class="help-block" v-if="!!hospitalErrors.name">
                      <small><strong>{{ hospitalErrors.name }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': hospitalErrors.country_id}">
                <label for="hospital-country" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Country:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <select id="hospital-country" class="form-control form-control-xs input-group-append"
                            v-model="hospital.country_id" required
                            :disabled="!editable"
                    >
                        <option :value="null">--- No Country ---</option>
                        <option v-for="countryKey in countryKeys"
                                :key="countryKey.id"
                                :value="countryKey.id"
                        >{{ countryKey.name }}</option>
                    </select>
                    <span class="help-block" v-if="!!hospitalErrors.country_id">
                      <small><strong>{{ hospitalErrors.country_id }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': hospitalErrors.crew_covid_test_country_id}">
                <label for="hospital-other-country" class="col col-sm-4 col-form-label font-weight-bolder text-right">
                    Other Country:
                </label>
                <div class="col col-sm-8 col-form-label p-0">
                    <select id="hospital-other-country" class="form-control form-control-xs input-group-append"
                            v-model="hospital.crew_covid_test_country_id" required
                            :disabled="!editable"
                    >
                        <option :value="null">--- No Country ---</option>
                        <option v-for="otherCountryKey in otherCountryKeys"
                                :key="otherCountryKey.id"
                                :value="otherCountryKey.id"
                        >{{ otherCountryKey.name }}</option>
                    </select>
                    <span class="help-block" v-if="!!hospitalErrors.crew_covid_test_country_id">
                      <small><strong>{{ hospitalErrors.crew_covid_test_country_id }}</strong></small>
                    </span>
                </div>
            </div>

            <hr />
            <div class="text-right">
                <button type="submit" class="btn btn-warning btn-sm btn-xs mr-3 font-weight-bolder" v-if="!guest"
                        :key="'edit-hospital'"
                >
                    <i class="fas fa-edit"></i>
                    {{ editable ? 'Update' : 'Edit' }}
                </button>
                <button class="btn btn-danger btn-sm btn-xs font-weight-bolder"
                        v-if="editable"
                        @click="cancelEdit"
                >
                    <span class="fas fa-ban"></span>
                </button>
            </div>

        </form>

    </app-modal>
</template>

<script>
/* eslint-disable */
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import { gateMixin } from "@/mixins/gateMixin";
import { mapActions, mapGetters} from "vuex";
import AppModal from "@/components/elements/AppModal";

export default {
    name: "ViewHospital",

    components: { AppModal },

    mixins: [ vueAppMixin, formMixin, gateMixin ],

    props: {
        viewHospital: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            hospital: {},
            hospitalErrors: {},
            editable: false
        }
    },

    methods: {
        ...mapActions([
            'updateHospital'
        ]),

        async confirmUpdateHospital() {
            if(this.editable) {
                if(await this.confirmUpdate()) {
                    let updatedHospital = await this.updateHospital(this.hospital);
                    if(updatedHospital) {
                        if(updatedHospital.errors) {
                            this.hospitalErrors = updatedHospital.errors;
                        } else {
                            this.successAlert('Hospital Details Successfully Updated', 'UPDATE');
                            document.getElementById('close-view-hospital').click();
                        }
                    } else {
                        this.errorAlert('Failed to update Hospital Details', 'UPDATE');
                    }
                }
            } else {
                this.editable = true;
            }
        },

        cancelEdit() {
            this.editable = false;
            this.hospital = Object.assign({}, this.viewHospital);
        }

    },

    computed: {
        ...mapGetters([
            'countryKeys',
            'otherCountryKeys'
        ])
    },

    watch: {
        viewHospital() {
            this.hospital = Object.assign({}, this.viewHospital);
            this.editable = false;
        }
    }
}
</script>

<style scoped>

</style>